import axios from 'axios';

export default {
    recuperar_Provi (p_email, p_usuario, p_nrosiniestro, p_nropoliza, p_nroendoso) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garsiniestros.recuperar_Provi",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_nrosiniestro": p_nrosiniestro,
					"p_nropoliza": p_nropoliza,
					"p_nroendoso": p_nroendoso
				  })
			})
	},

	recuperar_moneda(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_compp_consultas.recuperar_moneda",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario
				  })
			})
	},

	reg_provision(p_email, p_usuario, p_nrosiniestro, p_moneda, p_nomina, p_registro){
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garsiniestros.reg_provision",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_nrosiniestro": p_nrosiniestro,
					"p_moneda": p_moneda,
					"p_nomina": p_nomina,
					"p_registro": p_registro
				  })
			})
	},		
	
	recuperar_beneficiarios (p_email, p_usuario, p_nrosiniestro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garsiniestros.recuperar_beneficiarios",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_nrosiniestro": p_nrosiniestro
				  })
			})
	},

	insert_update_beneficiario(p_email, p_usuario, p_sbesiniestro, p_sbecodbenef, p_sbemoneda, p_sbemonto) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garsiniestros.insert_update_beneficiario",
				"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_sbesiniestro": p_sbesiniestro, 
				"p_sbecodbenef": p_sbecodbenef, 
				"p_sbemoneda": p_sbemoneda, 
				"p_sbemonto": p_sbemonto
				})
			})
	},

	delete_beneficiario(p_email, p_usuario, p_sbesiniestro, p_sbecodbenef) {
		return axios
			.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_garsiniestros.delete_beneficiario",
			"p_args_in": JSON.stringify({
			"p_usuario": p_usuario,
			"p_sbesiniestro": p_sbesiniestro, 
			"p_sbecodbenef": p_sbecodbenef, 
			})
		})
	},

	buscar_beneficiario(p_email, p_usuario, p_sbecodbenef) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garsiniestros.buscar_beneficiario",
				"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_sbecodbenef": p_sbecodbenef
				})
			})
	},
}